import { css, styled } from 'styled-components';
import { WrapperProps } from './types';

const Wrapper = styled('div').withConfig({
  shouldForwardProp: (prop) => !['crop'].includes(prop),
})<WrapperProps>`
  .ovenplayer {
    aspect-ratio: 9/16;
    height: 100vh;
    width: calc(100vh * (9 / 16)) !important;
  }

  video {
    object-fit: cover;

    ${(props) =>
      props.crop &&
      css`
        transform: scale(2) translate(-25%, -50%);
        transform-origin: top left;
      `}
  }
`;

export { Wrapper };
